export const GET_RECALL_LIST_START = "GET_RECALL_LIST_START";
export const GET_RECALL_LIST_SUCCESS = "GET_RECALL_LIST_SUCCESS";
export const GET_RECALL_LIST_ERROR = "GET_RECALL_LIST_ERROR";

export const LOAD_RECALL_LIST_START = "LOAD_RECALL_LIST_START";
export const LOAD_RECALL_LIST_SUCCESS = "LOAD_RECALL_LIST_SUCCESS";
export const LOAD_RECALL_LIST_ERROR = "LOAD_RECALL_LIST_ERROR";

export const SET_RECALL_LIST_FROM_DATE = "SET_RECALL_LIST_FROM_DATE";
export const SET_RECALL_LIST_TO_DATE = "SET_RECALL_LIST_TO_DATE";
